export enum LEVEL_STATUS {
  ACTIVE = "active",
  IN_PROGRESS = "in_progress",
  EMPTY = "empty",
  FILLED_ONE = "filled_one",
  FILLED_TWO = "filled_two",
  FILLED_HALF = "filled_half",
  COMPLETED = "completed",
  FAILED = "failed",
  INACTIVE = "inactive",
  ERROR = "error",
  ACTIVE_CHANGE_REQUESTED = "active_change_requested",
  FAILED_NO_DETAILS = "failed_no_details",
  COMPLETED_NO_SIGNIFICANT_CHANGES = "completed_no_significant_changes"
}
